/** Patient onboarding (flow PATIENT_V1) - values shared with the onboarding API. */

/** GET /onboarding/status → nextStep while the patient still has to go through OB1–OB5. */
export const PATIENT_ONBOARDING_STEP = 'PATIENT_ONBOARDING';

/** Screens, in order - also the `exitStep` values of POST /onboarding/patient/finish. */
export const ONBOARDING_STEPS = { OB1: 'OB1', OB2: 'OB2', OB3: 'OB3', OB4: 'OB4', OB5: 'OB5' };

/** `exitType` of POST /onboarding/patient/finish. */
export const ONBOARDING_EXIT_TYPES = {
  SKIPPED: 'SKIPPED',
  FIRST_SESSION: 'FIRST_SESSION',
  HOME: 'HOME',
};
